import React, { useEffect, useState } from "react";
import { TitleBar } from "../components/TitleBar";

export default function BaseLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isWindows, setIsWindows] = useState(false);

  useEffect(() => {
    const checkPlatform = async () => {
      try {
        if (window.electronWindow?.getPlatform) {
          const platform = await window.electronWindow.getPlatform();
          setIsWindows(platform === "win32");
        }
      } catch (error) {
        console.error("Failed to get platform:", error);
      }
    };

    checkPlatform();
  }, []);

  return (
    <>
      <TitleBar />
      <main 
        className={`h-screen p-2 bg-background text-foreground ${isWindows ? "pt-10" : ""}`}
      >
        {children}
      </main>
    </>
  );
}
